<template>
  <div>
    <b-card-header header-tag="header" class="p-1" role="tab" id="card-header">
      <b-button-toolbar justify>
        <b-button variant="dark" size="sm" style="width: 50px;">{{this.question.score}}</b-button>
        <b-button
          style="width: calc(100% - 100px);"
          
          v-b-toggle="'accordion-'+this.keyId"
          variant="info"
          @click="seleccionar"
        ><h4>{{this.question.body}}</h4></b-button>
        <b-button size="sm" style="width: 50px;" variant="dark" @click="setFavorite(question)">
          <b-icon v-if="!this.question.favorite" icon="star" aria-hidden="true" font-scale="1.6"></b-icon>
          <b-icon v-else icon="star-fill" variant="warning" aria-hidden="true" font-scale="1.6"></b-icon>
        </b-button>
      </b-button-toolbar>
    </b-card-header>
    <AnswerComponent :keyID="this.keyId" :answer="question" />
  </div>
</template>

<script>
import AnswerComponent from "./../answers/Answer.vue";
import { editQA } from "./../../api/conection";
export default {
  name: "Question",
  components: {
    AnswerComponent
  },
  props: {
    keyId: {
      type: Number,
      default: 0
    },
    question: {
      type: Object,
      default: {}
    }
  },
  methods: {
    seleccionar() {
      this.$store.dispatch("selectQAAction", this.question);
    },
    setFavorite(qa) {
      const { 
        question_id, 
        body,
        favorite,
        score,
        answers, 
        categories, 
        subcategories 
      } = qa;
      const payload = { 
        question_id, 
        body,        
        score,
        answers, 
        categories, 
        subcategories,
        favorite: !favorite 
      };
      editQA(payload, question_id)
        .then(editQuest => {
          if (editQuest.message !== "") {
            qa.favorite = !favorite;
            this.$store.dispatch("updateQAAction", qa);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  data() {
    return {};
  }
};
</script>

<style>
#card-header {
  position: fixed;
  height: 100vh;
  width: 100vw;
}
#b-question-group {
  width: 100%;
  min-width: 100%;
}
